export default {
    computed: {
        productBoosts() {return this.$store.getters.getCurrentProductBoosts }
    }
}